export const STANDARD_ISO_27001 = 'ISO 27001'
export const STANDARD_DORA = 'DORA'
export const STANDARD_ENS = 'ENS'
export const STANDARD_PCI_DSS = 'PCI DSS'
export const STANDARD_ISO_9001 = 'ISO 9001'
export const STANDARD_NIS2 = 'NIS2'
export const STANDARD_SOC2 = 'SOC2'
export const STANDARD_ISO_42001 = 'ISO 42001'
export const STANDARD_GDPR = 'RGPD'
export const STANDARD_ISO_14001 = 'ISO 14001'
export const STANDARD_ISO_27017 = 'ISO 27017'
export const STANDARD_ISO_27018 = 'ISO 27018'

const STANDARD_LIST = [
  STANDARD_ISO_27001,
  STANDARD_DORA,
  STANDARD_ENS,
  STANDARD_PCI_DSS,
  STANDARD_ISO_9001,
  STANDARD_NIS2,
  STANDARD_SOC2,
  STANDARD_ISO_42001,
  STANDARD_GDPR,
  STANDARD_ISO_14001,
] as const
export type IStandardName = (typeof STANDARD_LIST)[number]
export const STANDARDS: string[] = [...STANDARD_LIST]
export function isStandardName(standard: string): standard is IStandardName {
  return STANDARDS.includes(standard)
}
// Shown in the Trust Center but not managed as compliance standards in the platform
const TRUST_CENTER_ONLY_STANDARD_LIST = [STANDARD_ISO_27017, STANDARD_ISO_27018] as const
export type ITrustCenterStandardName = IStandardName | (typeof TRUST_CENTER_ONLY_STANDARD_LIST)[number]
const TRUST_CENTER_STANDARDS: string[] = [...STANDARD_LIST, ...TRUST_CENTER_ONLY_STANDARD_LIST]
export function isTrustCenterStandardName(standard: string): standard is ITrustCenterStandardName {
  return TRUST_CENTER_STANDARDS.includes(standard)
}
export const STANDARD_IMAGES: Record<string, string> = {
  [STANDARD_ISO_27001]: '/standards/iso-27001-logo.svg',
  [STANDARD_DORA]: '/standards/dora-logo.svg',
  [STANDARD_ENS]: '/standards/ens-logo.svg',
  [STANDARD_PCI_DSS]: '/standards/pci-dss-logo.svg',
  [STANDARD_ISO_9001]: '/standards/iso-9001-logo.svg',
  [STANDARD_NIS2]: '/standards/nis2-logo.svg',
  [STANDARD_SOC2]: '/standards/soc2-logo.svg',
  [STANDARD_GDPR]: '/standards/gdpr-logo.svg',
  [STANDARD_ISO_42001]: '/standards/iso-42001-logo.svg',
  [STANDARD_ISO_14001]: '/standards/iso-14001-logo.svg',
  [STANDARD_ISO_27017]: '/standards/iso-27017-logo.svg',
  [STANDARD_ISO_27018]: '/standards/iso-27018-logo.svg',
} satisfies Record<ITrustCenterStandardName, string>
export const STANDARD_NAMES: Record<string, string> = {
  [STANDARD_ISO_27001]: 'ISO 27001:2022',
  [STANDARD_DORA]: 'DORA',
  [STANDARD_ENS]: 'ENS',
  [STANDARD_PCI_DSS]: 'PCI DSS',
  [STANDARD_ISO_9001]: 'ISO 9001:2015',
  [STANDARD_NIS2]: 'NIS2',
  [STANDARD_SOC2]: 'SOC2',
  [STANDARD_GDPR]: 'GDPR',
  [STANDARD_ISO_42001]: 'ISO 42001:2023',
  [STANDARD_ISO_14001]: 'ISO 14001:2015',
  [STANDARD_ISO_27017]: 'ISO 27017',
  [STANDARD_ISO_27018]: 'ISO 27018',
} satisfies Record<ITrustCenterStandardName, string>
